<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rOwPO8/tc-custom/9783988269812.jpg?1704453362407" alt="This image is the cover for the book Andersonville Diary, Escape, and List of Dead, with Name, Co., Regiment, Date of Death and No. Of Grave in Cemetry, The World At War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Andersonville Diary, Escape, and List of Dead, with Name, Co., Regiment, Date of Death and No. Of Grave in Cemetry, The World At War
      </h1>
      <p class="bookDescription body article font2">
        <p>Andersonville Diary, Escape, and List of the Dead is a primary source documents which lists soldiers held in the horrific Confederate POW camp.(amazon)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John L. Ransom
      </h2>
      
      <p class="authorDescription body article">John L. Ransom (1843-1919) was an American author and Civil War veteran known for his compelling and detailed memoir, "Andersonville Diary." This diary provides a firsthand account of his experiences as a prisoner of war at the notorious Confederate prisoner-of-war camp, Andersonville, during the American Civil War. John L. Ransom's "Andersonville Diary" remains an essential source for historians and researchers studying the Civil War and the experiences of prisoners of war. His firsthand account provides a chilling and detailed look into the suffering and survival of Union prisoners held in the Confederate prison camp of Andersonville during the war.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?298f30d4